module.exports = __webpack_public_path__ + "flyer_background_christmas_wreath_115-491a0c8468b3f915a421ff44b688cba0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_christmas_wreath_115.jpg
// module id = 1621
// module chunks = 1